/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/init-declarations */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
// https://codepen.io/brian-baum/pen/mJZxJX
const SmoothScroll = {
    timer: null as any,
    stop() {
        clearTimeout(this.timer);
    },
    scrollTo(node: any) {
        const settings = {
            duration: 600,
            easing: {
                outQuint: (x: number, t: number, b: number, c: number, d: number) => {
                    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
                },
            },
        };
        const nodeTop = node.offsetTop;
        const nodeHeight = node.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowHeight = window.innerHeight;
        const offset = window.pageYOffset;
        const delta = nodeTop - offset;
        const bottomScrollableY = height - windowHeight;
        const targetY = bottomScrollableY < delta ? bottomScrollableY - (height - nodeTop - nodeHeight + offset) : delta;
        const startTime = Date.now();
        let percentage = 0;
        if (this.timer) {
            clearInterval(this.timer);
        }
        function step(this: any) {
            let yScroll;
            const elapsed = Date.now() - startTime;
            if (elapsed > settings.duration) {
                clearTimeout(this.timer);
            }
            percentage = elapsed / settings.duration;
            if (percentage > 1) {
                clearTimeout(this.timer);
            }
            else {
                yScroll = settings.easing.outQuint(0, elapsed, offset, targetY, settings.duration);
                //There isn't really a guarantee that the window object will exist in tests when used
                //in a setTimeout as it may have been cleaned up.
                window?.scrollTo(0, yScroll);
                if (this) {
                    this.timer = setTimeout(step, 10);
                }
            }
        }
        this.timer = setTimeout(step, 10);
    },
};
export default SmoothScroll;
